import { Store } from '@reduxjs/toolkit';

class StateService {
    private static store: Store;

    public static injectStore = (store: Store) => (StateService.store = store);

    public static readonly getAccessToken = (): string | undefined =>
        StateService.store.getState().auth.authInfo?.accessToken;

    public static readonly getSalesId = (): string | undefined => StateService.store.getState().order?.salesId;
}

export { StateService };
